import { getToken } from '../../Utils/authUtils';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { REPORTS } from '../../constant';

interface Payload {
  templateId: string;
}

export const getReportTemplatesByIdApi = createAsyncThunk(
  'Get Report Template',
  async (payload: Payload, { rejectWithValue }) => {
    try {
      const requestOptions = {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + getToken(),
        },
      };
      let res = await fetch(
        REPORTS.GET_REPORT_TEMPLATE_BY_ID_URL + '/' + payload.templateId,
        requestOptions
      );

      // Check if the response is not okay (status is 400 or other errors)
      if (!res.ok) {
        const errorData = await res.json(); // Extract error message from the res
        return rejectWithValue(errorData.msg || 'Unable to Get Report Template');
      }

      const data = await res.json();
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
